import React, { useState, useEffect } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import Checkout from '../Pages/buyer/CheckoutPage';
import FloatingChatWidget from '../Components/buyer/FloatingChatWidget';
import Upgrade from '../Pages/seller/Upgrade';
import SellerPostings from '../Pages/seller/SellerPostings';
import axios from 'axios';
import Loader from '../Components/utils/Loader';
import OrderDetailsPage from '../Pages/buyer/OrderDetailsPage';


const CheckoutStripeContainer = () => {

    const [stripePromise, setStripePromise] = useState(null);

    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchStripeKey = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/settings/admin/keys`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                if (response.data.success) {
                    const stripePublishableKey = response.data.stripePublishableKey;
                    const stripe = loadStripe(stripePublishableKey);
                    setStripePromise(stripe);
                }
            } catch (error) {
                console.error("Error fetching Stripe keys:", error);
            }
        };

        fetchStripeKey();
    }, [token]);

    if (!stripePromise) return <Loader type="simpleMax" />;

    return (
        <>
            <Elements stripe={stripePromise}>
                <Checkout />
            </Elements>
            <FloatingChatWidget />
        </>
    );
};

const UpgradeStripeContainer = () => {

    const [stripePromise, setStripePromise] = useState(null);

    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchStripeKey = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/settings/admin/keys`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                if (response.data.success) {
                    const stripePublishableKey = response.data.stripePublishableKey;
                    const stripe = loadStripe(stripePublishableKey);
                    setStripePromise(stripe);
                }
            } catch (error) {
                console.error("Error fetching Stripe keys:", error);
            }
        };
        fetchStripeKey();
    }, [token]);

    if (!stripePromise) return <Loader type="simpleMax" />;

    return (
        <Elements stripe={stripePromise}>
            <Upgrade />
        </Elements>
    );
};

const OrderDetailsStripeContainer = () => {

    const [stripePromise, setStripePromise] = useState(null);

    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchStripeKey = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/settings/admin/keys`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                if (response.data.success) {
                    const stripePublishableKey = response.data.stripePublishableKey;
                    const stripe = loadStripe(stripePublishableKey);
                    setStripePromise(stripe);
                }
            } catch (error) {
                console.error("Error fetching Stripe keys:", error);
            }
        };
        fetchStripeKey();
    }, [token]);

    if (!stripePromise) return <Loader type="simpleMax" />;

    return (
        <Elements stripe={stripePromise}>
            <OrderDetailsPage />
        </Elements>
    );
};

/**
 * Postings needs Stripe because the boost purchase modal is opened from here.
 */
const PostingsStripeContainer = () => {

    const [stripePromise, setStripePromise] = useState(null);

    const token = localStorage.getItem("token");

    useEffect(() => {
        const fetchStripeKey = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_Backend_Host_Name}/api/v1/settings/admin/keys`,
                    { headers: { Authorization: `Bearer ${token}` } }
                );
                if (response.data.success) {
                    const stripePublishableKey = response.data.stripePublishableKey;
                    const stripe = loadStripe(stripePublishableKey);
                    setStripePromise(stripe);
                }
            } catch (error) {
                console.error("Error fetching Stripe keys:", error);
            }
        };
        fetchStripeKey();
    }, [token]);

    // The listings table must still render if Stripe is unreachable; only the
    // boost modal depends on it.
    if (!stripePromise) return <SellerPostings />;

    return (
        <Elements stripe={stripePromise}>
            <SellerPostings />
        </Elements>
    );
};

export { CheckoutStripeContainer, UpgradeStripeContainer, OrderDetailsStripeContainer, PostingsStripeContainer };